import React from "react";
import { Link } from "react-router-dom";
import { Page, PageHeader } from "components/ui/Page";
import { TwoToOneLayout, PageColumn } from "components/ui/PageColumns";
import { LargeSpacer } from "components/ui/VerticalSpacers";

import { BillingSummaryCard } from "components/cards/BillingSummaryCard";
import { TransactionsCard } from "components/cards/TransactionsCard";
import { useSlice } from "components/hooks/useSlice";

export default function BillingDetailsPage() {
  const { hasFinancialsTab } = useSlice("myStatus");

  return (
    <Page>
      <PageHeader>
        {hasFinancialsTab ? (
          <Link to="/finances">My Finances</Link>
        ) : (
          <>My Finances</>
        )}{" "}
        &raquo; Transactions
      </PageHeader>
      <LargeSpacer />
      <TwoToOneLayout>
        <PageColumn>
          <BillingSummaryCard />
        </PageColumn>
        <PageColumn>
          <TransactionsCard />
        </PageColumn>
      </TwoToOneLayout>
    </Page>
  );
}
